import React from 'react';
import PropTypes from 'prop-types';
import { withModalActions } from 'core/hocs';
import { FormattedTag } from 'core/components';
import { ButtonWithLoader } from 'components/button-with-loader/button-with-loader';
import { IconAlert } from 'components/icons/icon-alert/icon-alert';
import { MODAL_IDS } from 'src/constants';

import './too-many-attempts-2fa.scss';

const TooManyAttempts2faUI = ({
  openModalAndCloseOthers
}) => {
  function onClick() {
    openModalAndCloseOthers(MODAL_IDS.SUPPORT);
  }

  return (
    <div
      className="too-many-attempts-2fa"
    >
      <div
        className="d-flex justify-content-center"
      >
        <IconAlert outlined />
      </div>

      <div
        className="too-many-attempts-2fa-content d-flex flex-column my-3"
      >
        <FormattedTag
          tag="div"
          id="too-many-attempts-2fa.title"
          className="h2 text-gray-white text-center"
        />
        <FormattedTag
          tag="span"
          id="too-many-attempts-2fa.desc"
          className="text-white-65 text-center px-1"
        />
      </div>

      <div
        className="d-flex justify-content-center"
      >
        <FormattedTag
          tag={ButtonWithLoader}
          id="too-many-attempts-2fa.btn.title"
          isLoading={false}
          color="primary"
          size="lg"
          className="too-many-attempts-2fa-button"
          onClick={onClick}
        />
      </div>
    </div>
  );
};

TooManyAttempts2faUI.propTypes = {
  openModalAndCloseOthers: PropTypes.func.isRequired,
};

export const TooManyAttempts2fa = withModalActions(TooManyAttempts2faUI);
